import styled from "styled-components";
import { when } from "../styles/theme.js";
import PropTypes from "prop-types";
// import { lgWidth } from "./sideBar.js";

// todo: sample page container to be changed

const PageContainer = styled.div`
  margin-left: 1.2rem;
  margin-right: 1.2rem;

  ${when("sm")} {
    margin-left: 1.8rem;
    margin-right: 1.8rem;
  }

  ${when("md")} {
    margin-left: 2.4rem;
    margin-right: 2.4rem;
  }

  ${when("lg")} {
    margin: auto;
    width: 960px;
    ${(props) =>
      props.hasSideBar
        ? `padding-left: ${
            props.theme.sideBarWidth.lg + props.theme.gutterWidth.lg
          }rem;`
        : ""};
  }

  ${when("xl")} {
    width: 1140px;
    ${(props) =>
      props.hasSideBar
        ? `padding-left: ${
            props.theme.sideBarWidth.xl + props.theme.gutterWidth.xl
          }rem;`
        : ""};
  }

  ${when("xxl")} {
    width: 1320px;
    ${(props) =>
      props.hasSideBar
        ? `padding-left: ${
            props.theme.sideBarWidth.xxl + props.theme.gutterWidth.xxl
          }rem;`
        : ""};
  }
`;

PageContainer.defaultProps = {
  hasSideBar: false,
};

PageContainer.propTypes = {
  hasSideBar: PropTypes.bool,
};

export default PageContainer;
